import {mapActions, mapMutations, mapGetters} from "vuex";

export default {
    name: "product-card",
    components: {},
    props: {
        item: {
            type: Object,
            default: () => {
            }
        }
    },
    data() {
        return {
            payload: {
                count: 0,
                name: '',
                price: '',
                image:'',
            },

        }
    },
    created() {
    },
    computed: {
        ...mapGetters({})
    },
    methods: {
        ...mapMutations({
            addToBasket: 'order/ADD_BASKET'
        }),
        ...mapActions({
            fetchProduct: 'card/PRODUCT_DATA',
            currentOrder: 'order/CURRENT_ORDER'
        }),

    }

}
